import { httpClient } from '../http/httpClient'

export interface UserAdminPasswordUpdateParams {
  oldPassword: string
  password: string
}

export const userAdminPasswordUpdate = async (
  params: UserAdminPasswordUpdateParams,
) => {
  const { data } = await httpClient.patch('/user/me/password', params)

  return data
}
